import { create } from 'zustand';
import { setItem, removeItem, getItem } from './storage';
import { LogInRes } from '@/api/types/authTypes';
interface ProfileState {
  userData: LogInRes | null;
  authToken: string | null;
  forgotPasswordEmail: string | null;
  setUserData: (data: LogInRes) => void;
  setAuthToken: (token: string) => void;
  logout: () => void;
  setForgotPasswordEmail: (email: string) => void;
}

export const useProfileStore = create<ProfileState>((set) => ({
  userData: getItem('userData') || null,
  authToken: getItem('authToken') || null,
  forgotPasswordEmail: getItem('forgotPasswordEmail') || null,
  setUserData: (data) => {
    setItem('userData', data);
    set({ userData: data });
  },
  setAuthToken: (token) => {
    setItem('authToken', token);
    set({ authToken: token });
  },
  setForgotPasswordEmail: (email) => {
    setItem('forgotPasswordEmail', email);
    set({ forgotPasswordEmail: email });
  },
  logout: () => {
    removeItem('userData');
    removeItem('authToken');
    removeItem('forgotPasswordEmail');
    set({
      userData: null,
      authToken: null,
      forgotPasswordEmail: null,
    });
  },
}));
